import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import StarsComponent from '@/components/stars';

const TitleDescription = (props: any) => {
  const { facilityData, ratingData } = props;
  const [showStoreId, setShowStoreId] = useState(false);

  const scrollToReviews = () => {
    const reviews = document.getElementById('client-reviews-google');
    if (!reviews) return;
    window.scrollTo({ top: reviews.offsetTop - 128, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleKeyPress = (event: any) => {
      if (event.shiftKey && event.key.toUpperCase() === 'L') {
        setShowStoreId((prev) => !prev);
      }
    };

    // Add event listener on mount
    window.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <>
      <div className="d-flex align-items-center mt-3 mb-2">
        {ratingData?.averageRating != null &&
          !Number.isNaN(ratingData.averageRating) && (
            <StarsComponent data={ratingData?.averageRating} toggleText={true}>
              {ratingData?.averageRating}
            </StarsComponent>
          )}
        {ratingData?.numberOfReviews && (
          <h6
            className="sv-storeAddress mb-0 mt-1 ms-2"
            style={{ cursor: 'pointer' }}
            onClick={() => scrollToReviews()}
          >
            {ratingData?.numberOfReviews} <FormattedMessage id="reviews-of" />
            {'  '}
            <img src="/images/right-blue-arrow.svg" alt="Arrow icon" />
          </h6>
        )}
      </div>
      <div className="sv-storeNameID">
        <h6 className="sv-storeName mb-0">{facilityData?.attributes?.Title}</h6>
        <div
          className="sv-storeID ms-2"
          id="store-id"
          style={{ display: showStoreId ? 'inline-block' : 'none' }}
        >
          {facilityData?.attributes?.Facility_ID}
        </div>
      </div>
      <p
        className="sv-store-description mb-0"
        dangerouslySetInnerHTML={{
          __html: facilityData?.attributes?.Facility_Description,
        }}
      />
    </>
  );
};

export default TitleDescription;
